import { PlusSquareIcon } from '@phosphor-icons/react';
import { FC } from 'react';
import { Link, useNavigate } from 'react-router-dom';

import { Button } from '@/components/ui/button';
import { PageHeader } from '@/modules/common';
import { Routes } from '@/router/routes';

import { GcrsTable } from '../components';
import { GcrDetails } from '../types';

export const GcrsPage: FC = () => {
  const navigate = useNavigate();

  const redirectToGcrDetails = (item: GcrDetails) => {
    navigate(Routes.GcrDetails.replace(':id', item.id));
  };

  return (
    <div>
      <PageHeader
        title="GCR Files"
        actions={[
          <Link to={Routes.NewGcr} key="new-gcr" data-testid="add-new-gcr-link">
            <Button data-testid="add-new-gcr-button">
              <PlusSquareIcon />
              Add new GCR file
            </Button>
          </Link>,
        ]}
      />

      <GcrsTable onClick={redirectToGcrDetails} />
    </div>
  );
};
